import {
  FOC_TOUR_LABEL_OPS,
  focFeedbackPopoverHtml,
} from '../focTourFeedback';
import { FOC_OPS_TOUR_HREF as HREF } from '../focTourHrefs';
import {
  FOC_REQUIRED_DISPOSITION,
  focOpsTourPopoverHtml,
  requirement,
  type FocOpsTourStepDef,
} from './focOpsTourTypes';

export const FOC_OPS_TOUR_PARAM = 'focOpsTour';
export const FOC_OPS_TOUR_HREF = HREF;
export const FOC_OPS_SEAT_SLUG = 'operations-section-chief';
export { focOpsTourPopoverHtml };

export function focOpsTourSeatHref(incidentId: string): string {
  return `/iap/${incidentId}/seat/${FOC_OPS_SEAT_SLUG}?${FOC_OPS_TOUR_PARAM}=1`;
}

export const FOC_OPS_TOUR_STEPS: FocOpsTourStepDef[] = [
  {
    id: 'sectionIntro',
    tour: 'ops-workspace',
    title: FOC_TOUR_LABEL_OPS,
    description:
      'The Operations Section workspace supports tactical implementation of command objectives, strategy and tactics, current/next operational-period organization, assignments, resource requirements, operational maps, work analysis, safety coordination, ICS 204, operational status, and Operations Brief preparation.',
  },
  requirement({
    id: 'ops001',
    requirementId: 'FOC-OPS-001',
    name: 'Operations Section Workspace',
    disposition: FOC_REQUIRED_DISPOSITION,
    tour: 'ops-workspace',
    description:
      'PRATUS provides an Operations Section workspace supporting tactical implementation of command objectives, strategy and tactics development, current and next operational-period organization, assignments, resource requirements, operational maps, work analysis, safety coordination, ICS 204 development, operational status, and Operations Brief preparation.',
    bullets: [
      'FOC-OPS-001a — Assignment and Resource Linkage: links objectives, strategies, tactics, ICS 215 work assignments, ICS 215A hazards/mitigations, resource requirements, ICS 204 assignments, map features, and operational-period organization.',
      'FOC-OPS-001b — Operational Status: update operational status, actions, resource needs, constraints, assignment changes, and information needed by Situation, Planning, Logistics, Finance/Admin, Command, and other authorized users.',
      'FOC-OPS-001c — Demobilization Contributions: identify tactical resources that can be released, provide operational input to the Demobilization Plan, and coordinate approved release actions.',
    ],
  }),
  requirement({
    id: 'ops002',
    requirementId: 'FOC-OPS-002',
    name: 'Operational O / Current Operations Board',
    disposition: FOC_REQUIRED_DISPOSITION,
    tour: 'ops-workspace',
    description:
      'Supports the Operational O as the execution side of incident management while the next operational period is planned—managing approved assignments, current operations, changing conditions, resource movement, field status, emergent needs, and completion/blockage without disrupting Planning P for the next period.',
    bullets: [
      'FOC-OPS-002a — Current Operations Status: current-period objectives and assignments, Branch/Division/Group status, assigned resources, key accomplishments, problems/constraints, safety issues, emergent needs, and time-sensitive decisions.',
      'FOC-OPS-002b — Field Update Intake: field supervisors submit status, completion, resource/location changes, safety concerns, significant events, and requests; Operations validates and routes relevant updates.',
    ],
  }),
  requirement({
    id: 'ops003',
    requirementId: 'FOC-OPS-003',
    name: 'Assignment Lifecycle / ICS 204 and 204A',
    disposition: FOC_REQUIRED_DISPOSITION,
    tour: 'ops-workspace',
    description:
      'Supports assignment development, briefing, execution, update, and closeout using the authoritative assignment/workforce/resource data model and produces source-faithful ICS 204-CG and ICS 204A-CG outputs when applicable.',
    bullets: [
      'FOC-OPS-003a — Assignment Data Reuse: identifiers, Branch/Division/Group, supervisor/contact, resources, reporting location, work assignment, special instructions, communications, medical, safety, and map information reuse approved incident data where equivalent.',
      'FOC-OPS-003b — Assignment State and Change Control: draft, ready-for-review, approved/briefed, active, blocked, completed, cancelled, and superseded (or equivalent); post-approval changes are traceable with notification.',
      'FOC-OPS-003c — Field Assignment Package: assigned supervisors/field users quickly access approved assignment, map/location, communications, safety, medical/emergency, reporting instructions, resources, status-reporting method, and activity-log entry.',
    ],
  }),
  requirement({
    id: 'ops004',
    requirementId: 'FOC-OPS-004',
    name: 'Emergent Change and Next-Cycle Feedback',
    disposition: FOC_REQUIRED_DISPOSITION,
    tour: 'ops-workspace',
    description:
      'Operations can record conditions, resource needs, assignment changes, completed work, unresolved problems, and recommendations that must inform the next Planning P cycle. Approved/current operational changes remain distinguishable from proposals for the next operational period.',
  }),
  {
    id: 'focFeedback',
    title: 'FOC Feedback Notes',
    description: focFeedbackPopoverHtml(FOC_TOUR_LABEL_OPS),
  },
];

export function focOpsTourNavVisible(enabled: boolean): boolean {
  return enabled;
}

export function focOpsTourStepIds(): string[] {
  return FOC_OPS_TOUR_STEPS.map((step) => step.id);
}
